/**
 * @generated SignedSource<<acd90e492d803c85c4a86e7136f8aec8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotableOrder = "HOT" | "NEWEST" | "OLDEST";
export type ForumTopicsFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
  order?: VotableOrder | null | undefined;
};
export type ForumTopicsFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ForumTopicsFragment">;
  };
};
export type ForumTopicsFragmentPaginationQuery = {
  response: ForumTopicsFragmentPaginationQuery$data;
  variables: ForumTopicsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": "HOT",
  "kind": "LocalArgument",
  "name": "order"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v5/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = [
  (v6/*:: as any*/),
  (v12/*:: as any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isEntity"
  },
  (v13/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageThumbnail",
    "storageKey": null
  },
  (v7/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForumTopicsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v5/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ForumTopicsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "ForumTopicsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "concreteType": "TopicConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopicEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Forum",
                            "kind": "LinkedField",
                            "name": "forum",
                            "plural": false,
                            "selections": [
                              (v10/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  (v10/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forumOwnerKind",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          (v11/*:: as any*/)
                                        ],
                                        "concreteType": "EventCompetitionConnection",
                                        "kind": "LinkedField",
                                        "name": "events",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventCompetition",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Event",
                                                "kind": "LinkedField",
                                                "name": "event",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*:: as any*/),
                                                  (v7/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v7/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "events(first:1)"
                                      }
                                    ],
                                    "type": "Competition",
                                    "abstractKey": null
                                  },
                                  (v7/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v11/*:: as any*/),
                              {
                                "kind": "Literal",
                                "name": "order",
                                "value": "NEWEST"
                              }
                            ],
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v9/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v12/*:: as any*/),
                                      (v13/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "comments(first:1,order:\"NEWEST\")"
                          },
                          {
                            "alias": "viewerCanDelete",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "action",
                                "value": "DELETE_TOPIC"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "viewerCan",
                            "storageKey": "viewerCan(action:\"DELETE_TOPIC\")"
                          },
                          (v6/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "voterCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 10
                                  }
                                ],
                                "concreteType": "VotersConnection",
                                "kind": "LinkedField",
                                "name": "voters",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*:: as any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "voters(first:10)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EntityVote",
                                "kind": "LinkedField",
                                "name": "voted",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "score",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": "viewerCanVote",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "action",
                                    "value": "PUBLISH_VOTE"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "viewerCan",
                                "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
                              }
                            ],
                            "type": "Votable",
                            "abstractKey": "__isVotable"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "filters": [
                  "order"
                ],
                "handle": "connection",
                "key": "ForumTopicsFragment_topics",
                "kind": "LinkedHandle",
                "name": "topics"
              }
            ],
            "type": "Forum",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0fd4ce1db8b2fe977a2875fafe2a1cb",
    "id": null,
    "metadata": {},
    "name": "ForumTopicsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query ForumTopicsFragmentPaginationQuery(\n  $count: Int = 10\n  $cursor: String\n  $order: VotableOrder = HOT\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ForumTopicsFragment_2kH0K8\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment ForumTopicsFragment_2kH0K8 on Forum {\n  topics(after: $cursor, first: $count, order: $order) {\n    edges {\n      node {\n        id\n        ...TopicListItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TopicListItemFragment on Topic {\n  id\n  title\n  url\n  createdAt\n  commentCount\n  forum {\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      ... on Competition {\n        events(first: 1) {\n          nodes {\n            event {\n              slug\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  author {\n    __typename\n    username\n    ...EntityProfilePicFragment_49kWkb\n    id\n  }\n  comments(first: 1, order: NEWEST) {\n    nodes {\n      createdAt\n      author {\n        username\n        displayName\n        id\n      }\n      id\n    }\n  }\n  viewerCanDelete: viewerCan(action: DELETE_TOPIC)\n  ...VoteDisplayFragment\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "e78e867e3e6de40d5532e580f04d8a95";

export default node;
